import {
  SurveyQuotaSupplier,
  SurveyQuotaSupplierTarget,
} from '../models/survey-quota.model';

/**
 * Applies the update-current-target response's per-supplier targets to the
 * suppliers already in state.
 *
 * Left-joined on the suppliers in state: a target whose supplierRefId isn't
 * there is dropped, because the response carries no name or dates for it and
 * such a row could not be rendered. Everything the response doesn't return
 * (name, dates, valid clicks, …) is carried across from state.
 */
export function mergeQuotaSupplierTargets(
  suppliers: readonly SurveyQuotaSupplier[],
  targets: readonly SurveyQuotaSupplierTarget[],
): SurveyQuotaSupplier[] {
  const targetByRefId = new Map(
    targets.map((target) => [target.supplierRefId, target]),
  );

  return suppliers.map((supplier) => {
    const target = targetByRefId.get(supplier.supplierRefId);
    if (!target) {
      return supplier;
    }

    return {
      supplierRefId: supplier.supplierRefId,
      name: supplier.name,
      currentTarget: target.currentTarget,
      currentlyOpen: supplier.currentlyOpen,
      supplierCurrentlyOpen: supplier.supplierCurrentlyOpen,
      fielded: supplier.fielded,
      completeNeeded: target.completeNeeded,
      validClicks: supplier.validClicks,
      inProgress: supplier.inProgress,
      lastStartDate: supplier.lastStartDate,
      lastCompleteDate: supplier.lastCompleteDate,
      isPdsApplied: supplier.isPdsApplied,
      fee: supplier.fee,
    };
  });
}
